import React from 'react';
import {Navbar, SideNav} from '../components/Navbar';
import { Grid } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ProNav from '../components/pro.nav';
import Description from '../components/Pro.Description';
import Footer from '../components/Footer';
import {checkType} from '../util/utils';
import '../styles/css/Nav.console.css';
import '../styles/css/mobile.css';

export const Root = (props) => {
  let {sideNav, userState} = props.state;
  // navbar course icon needs to be rendered dynamically as well
  return(
    <Grid style={{height: "100%", minHeight:'90%',overflow:(sideNav?'hidden':'scroll')}}>
      <Navbar {...props} />
      <div className="container_center">
        {sideNav?<div id="black_box" onClick={()=>props.handlers.onSideNavClick()} />:null}
        <SideNav sideNav={props.state.sideNav} userState={userState}
          handler={props.handlers.onSideNavClick} logout={props.handlers.onLogOut}/>
        {props.children}
        {props.push&&
          <div className='noti'>
            {props.state.location!=='/premium/coach'&&
              <Link to="/premium/coach">
              {props.coachName}から新しいメッセージが到着しました。
            </Link>}
          </div>
        }
      </div>
      <Footer sideNav={props.sideNav}/>
    </Grid>
  );
};

export const ProRoot = (props) =>{
  let {pathName, is_first} = props;
  let {nav_type, description_type} = checkType(pathName, is_first);
  return(
    <div className="text-center">
      {!pathName.includes('/premium/personal-training/')&&
        <div>
          <ProNav type={nav_type} loc={pathName} />
          <Description type={description_type} />
        </div>
      }
      {props.children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Root.js